import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";

Vue.use(Vuex);

const state = {
  basicInfo: Cookies.get("basicInfo")
    ? JSON.parse(Cookies.get("basicInfo"))
    : Cookies.get("basicInfo"),
  payStuInfo: sessionStorage.getItem('payStuInfo') ? JSON.parse(sessionStorage.getItem('payStuInfo')) : { idNumber: "", registInfoId: "",relName:"",profName:"" }
};

const mutations = {
  BASICINFO(state, data) {
    console.log(data, "存基础信息");
    state.basicInfo = data;
    Cookies.set("basicInfo", data, { expires: 30, path: "/" });
  },
  // 保存支付配置信息
  SAVE_PAY_STU_INFO(state, data) {
    console.log(data, "保存支付配置信息");
    state.payStuInfo = data;
    sessionStorage.setItem('payStuInfo', JSON.stringify(data))
  },
  DEL_PAY_STU_INFO(state) {
    state.payStuInfo = {};
    sessionStorage.removeItem('payStuInfo')
  }
};

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js